/**
 * @description
 *
 * Here you should declare the state properties and it's initial values
 * @return {object} with state data
 */
import TBK from '../../../services/tbk'
const initialState = () => {
    return {
        token: localStorage.getItem('user-token') || '',
        status: '',
        user: JSON.parse(localStorage.getItem('user')) || null,
        cash_desk_token: localStorage.getItem('cash_desk_token') || '',
        cash_desk_id: localStorage.getItem('cash_desk_id'),
        permissions: JSON.parse(localStorage.getItem('permissions')) || [],
        hasLoadedOnce: false,
        // Cash Desk status (open/closed true/false)
        openCashDesk: localStorage.getItem('cash-desk-open')
            ? JSON.parse(localStorage.getItem('cash-desk-open'))
            : null,
        // Check if cash desk is open for more than one working day. If true, should ask to close cash desk (open/closed true/false)
        mustCloseCashDesk: localStorage.getItem('must-close-cash-desk')
            ? JSON.parse(localStorage.getItem('must-close-cash-desk'))
            : null,
        tbk: new TBK(
            localStorage.getItem('tbk-url') || 'https://localhost:5000/api/',
            localStorage.getItem('cash_desk_id')
        ),
    }
}

export default initialState
